module.exports = __webpack_public_path__ + "static/media/service4.91d70519.png";